import loadingScreen from './loading-screen.json' with { type: 'json' };

export default {
  loading_screen: loadingScreen,
};
